module.exports = __webpack_public_path__ + "assets/images/ending7_7a30c41865e623cf3d9ec30fb6074351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending7.png
// module id = 139
// module chunks = 0